import bus from "@/bus";

import { socket } from "@/plugins/socket";

import { useAuthStore } from "@/stores/auth";
import { usePropertiesStore } from "@/stores/properties";
import { useCountryStore } from "@/stores/country";
import { useProfileStore } from "@/stores/profile";

// Singleton state to track initialization
let isInitialized = false;
let initializationPromise = null;

export const initializeCountryData = async () => {
  const countryStore = useCountryStore();
  await countryStore.getCountryData();
};

export const initializeUserData = async () => {
  try {
    const authStore = useAuthStore();
    const propertiesStore = usePropertiesStore();
    const profileStore = useProfileStore();

    await Promise.all([
      propertiesStore.getPropertiesConfig(),
      profileStore.fetchProfile(),
    ]).catch(() => {
      /* Ignore */
    });

    // TODO: temporary check for avatar, since we need avatars in match screen
    if (!authStore.user || !authStore?.user?.avatar) {
      bus.global.emit("modal.preloader:open");
      await authStore.updateUserFromApi();
      bus.global.emit("modal.preloader:close");
    }
  } catch (ex) {
    console.error(ex);
  }
};

/**
 * Initialize app data once per session after authentication
 * Uses singleton pattern to ensure initialization only happens once
 */
export const initializeApp = async () => {
  // If already initialized, return immediately
  if (isInitialized) {
    return;
  }

  // If initialization is in progress, return the same promise
  if (initializationPromise) {
    return initializationPromise;
  }

  // Start initialization
  initializationPromise = (async () => {
    try {
      await Promise.all([initializeCountryData(), initializeUserData()]);
      socket().join("Users");
      isInitialized = true;
    } catch (error) {
      console.error("App initialization failed:", error);
      // Reset promise so it can be retried
      initializationPromise = null;
      throw error;
    }
  })();

  return initializationPromise;
};

/**
 * Reset initialization state
 */
export const resetInitialization = () => {
  isInitialized = false;
  initializationPromise = null;
};

/**
 * Check if app has been initialized
 */
export const isAppInitialized = () => {
  return isInitialized;
};
